import React, {useMemo} from "react";
import {useParams} from "react-router-dom";

import {TrashIconButton} from "../../atoms/buttons/buttons";
import {Td, Tr} from "../../atoms/tables/table";
import {FormField} from "../../molecules/inputs/form-field";
import CategoryLinkCell from "./category-link-cel";

export interface CategoryRowProps {
    id: string;
    label: string;
    slug: string;
    labelError: string;
    slugError: string;
    canRemove: boolean;
    count?: number;
    onChangeLabel: (id: string, newValue: string) => void;
    onChangeSlug: (id: string, newValue: string) => void;
    onRemove: (id: string) => void;
}

export const CategoryRow: React.FC<CategoryRowProps> = ({
    id,
    label,
    slug,
    labelError,
    slugError,
    canRemove,
    count,
    onChangeLabel,
    onChangeSlug,
    onRemove,
}) => {
    const {mediaId} = useParams();

    const shouldShowLink = useMemo(() => count !== undefined && !!mediaId, [count, mediaId]);

    return (
        <Tr key={id}>
            <Td>
                <FormField
                    noLabel
                    placeholder="カテゴリ名"
                    value={label}
                    onChange={(e) => onChangeLabel(id, e.currentTarget.value)}
                    onBlur={(e) => onChangeLabel(id, e.currentTarget.value)}
                    errorText={labelError}
                />
            </Td>
            <Td>
                <FormField
                    noLabel
                    placeholder="slug"
                    value={slug}
                    onChange={(e) => onChangeSlug(id, e.currentTarget.value)}
                    onBlur={(e) => onChangeSlug(id, e.currentTarget.value)}
                    errorText={slugError}
                />
            </Td>
            {shouldShowLink && (
                <>
                    {count === 0 ? (
                        <Td>{count}件</Td>
                    ) : (
                        <CategoryLinkCell
                            href={`/admin/${mediaId}/documents?categoryGroup=${slug}`}
                        >
                            {count}
                        </CategoryLinkCell>
                    )}
                </>
            )}

            <Td>{canRemove && <TrashIconButton onClick={() => onRemove(id)} />}</Td>
        </Tr>
    );
};
